export const UNGROUPED_GROUP_ID = "__ungrouped";
export const UNGROUPED_GROUP_NAME = "Outras unidades";
export const UNGROUPED_GROUP_SLUG = "outras-unidades";
export const DEFAULT_UNIT_GROUPING_MODE = "NONE";
export const DEFAULT_UNIT_GROUPING_LABEL = "Região";
export const UNIT_FIELD_TYPE = "unit_id";
export var UnitFilterDisplay;
(function (UnitFilterDisplay) {
    UnitFilterDisplay["GROUPS"] = "GROUPS";
    UnitFilterDisplay["UNITS"] = "UNITS";
})(UnitFilterDisplay || (UnitFilterDisplay = {}));
export const DEFAULT_UNIT_FILTER_DISPLAY = UnitFilterDisplay.GROUPS;
